<template>
  <div >
    <div v-if="getLocaltypes()==1">
    <div class="model-big">
      <div class="right-main" @click="toRouter(leftBigIma)">
         <div class="headfont">
          <h2>{{leftBigIma.homPageTitle}}</h2>
          <span class="spanonunt">{{leftBigIma.homPageContent}}</span>
        </div>
        <img :src="$imagepath+leftBigIma.homPageFilePath"  alt="图片加载中">
      </div>
      <div class="left-main">
        <div class="top" @click="toRouter(topImg)">
          <div class="topContent">
<span class="topspan">{{topImg.homPageTitle}}</span>
          </div>
          <img :src="$imagepath+topImg.homPageFilePath" >
          </div>

        <div class="down"  @click="toRouter(down)">
             <div class="topContent">
<span class="topspan">{{down.homPageTitle}}</span>
          </div>
          <img :src="$imagepath+down.homPageFilePath"></div>
      </div>
    </div>
  
    <!-- <div class="search-banner">
      <form class="fbox" action="search" method="get" role="search" style="margin-top:0px;">
        <div class="icon">
        </div>
        <input class="search-input" type="text" name="search" id="search" autocomplete="off" value placeholder="搜索您感兴趣的专业、院系、人物、新闻、活动...">
        <input type="hidden" name="lan" autocomplete="off" value="zh">
        <button class="search-btn no-focus" type="submit">搜索</button>
      </form>
      </div> -->
    
    <!-- <div>
      <div class="sear">
        <div class="sear-image"></div>
        <div class="sear-imput">

          <el-input placeholder="请输入内容" v-model="input1" clearable>
          </el-input>
        </div>
        <div class="sear-but">

          <el-button type="primary" icon="el-icon-search" @click="bushow">搜索</el-button>

        </div>
      </div>
    </div> -->

    <div class="who-box">
      <div class="banner-title">
        我是...
        <div>
          <div class="who-warp">

             <a href="#/communications?htmlpath=html%2Fthu_saw_fresh.htm&infoID=15&active=61&t=1664349394082">
              <el-button>新生</el-button>
            </a>
            <a href="#/communications?htmlpath=html%2F%2F49aa4eda-8cc7-4ea5-8d2e-ed68de3e21e01660294120491.htm&infoID=11&active=35&height=null&t=1663251602986">
              <el-button>未来学生</el-button>
            </a>
            <a href="#/ThreeMenus?htmlpath=39&infoID=15&active=39&height=null&t=1663251641885">
              <el-button plain>在校学生</el-button>
            </a>
            <a href="#/communications?htmlpath=html%2Ftbbuild.htm&infoID=17&active=47&height=null&t=1663251660497">
              <el-button plain>校友</el-button>
            </a>
            <a href="#/communications?htmlpath=html%2F%2F72c4582c-eb41-451f-a7b6-68786064bf211660292395780.htm&infoID=13&active=43&height=1200&t=1663251679053">
              <el-button plain>科研人员</el-button>
            </a>
            <a href="#/NewsAll?htmlpath=html%2F%2F7198329f-35fe-44ee-9203-4582b39af3761659695440486.html&infoID=11&active=34&height=null&t=1663251800503">
              <el-button plain>商业合作伙伴</el-button>
            </a>
            <a href="#/communications?htmlpath=html%2Ftbbuild.htm&infoID=11&active=46&height=null&t=1663251697300">
              <el-button plain>求职者</el-button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div id="middle-box-pure">
          <div id="section-title">
            <span id="text1">新闻</span>
            <span class="viewallnews">
                  <router-link to='/NewsAll' id="Newall"> 浏览全部
                  </router-link> </span>
        </div>
        <div id="model3" v-for="(news, index) in newslist" :key="index">
            <div id="news-item"  @click="getNew(news)" ><img class="image1" :src="imagepath + news.news_FILE_PATH" alt="加载失败"></div>
            <!-- <div id="news-item"><img class="image1" src="@/components/img/newsFile\c356962f-36b2-4189-ab0e-b7b05c25b2d61656563574691.jpg" alt="加载失败"></img></div> -->


            <div id="time-cate">{{ news.newsTime }}</div>
            <div id="news-title">{{ news.news_TITLE }}</div>
        </div>
    </div>

    <!-- <div class="footerBar2">
            <div class="contentBox">
          
            
            <div class="footer_logo">
             
              <img src="http://www.wxu.edu.cn/r/cms/thxy/thxy2/images/logo.jpg" width="200" height="40">
                <img src="http://www.ebookware.cn/video/uws_logo.jpg" width="200" height="80">
            </div>
            <div class="footer_left">
                
              <p style="margin-left:10px"> <span><a href="https://www.uws.ac.uk/">西苏格兰大学</a></span></p>
                <p style="margin-left:10px"> <span> <a href="http://www.wxu.edu.cn/">太湖学院</a> </span></p>
                <p style="margin-left:10px"> <span><a href="http://saw.wxu.edu.cn/">苏格兰学院旧址</a></span></p>
            </div>
            <div class="footer_mid">

              <p style="margin-left:10px"> <span>学院地址：江苏省无锡市钱荣路68号</span></p>
              <p style="margin-left:10px"> <span>招生咨询电话：0510-85509888 | 85522008 | 8550399</span></p>
                <p style="margin-left:10px"> <span>电话：0510-85502763 传真：0510-85502663</span></p>
            </div>
            <div class="footer_right">
                
                              <span>公众号</span>
                              <div class="con" style="display: true;"><img src="http://www.ebookware.cn/video/saw_QR.png" width="120"></div>
               
            </div>
            </div>

    </div> -->

  </div>
  <div  v-if="getLocaltypes()==2">
    <div class="model-big2" v-if="homeList.length>0">
  <el-carousel indicator-position="outside">
    <el-carousel-item v-for="(item,index) in homeList" :key="index">
      <img :src="$imagepath+item.homPageFilePath" >
    </el-carousel-item>
  </el-carousel>
    </div>

    <div id="section-title">
            <span id="text1">新闻</span>
            <span class="viewallnews">
                  <router-link to='/NewsAll' id="Newall"> 浏览全部
                  </router-link> </span>
        </div>

    <div   v-for="(news, index) in newslist" :key="index">
            <div id="news-item"   @click="getNew(news)" ><img class="image2" :src="imagepath + news.news_FILE_PATH" alt="加载失败"></div>
            <div id="time-cate2">{{ news.newsTime }}</div>
            <div id="news-title2">{{ news.news_TITLE }}</div>
        </div>
  </div>
  </div>

</template>

<script>
import {getLocaltype} from '../mainConfig/thu'
export default {

  mame: 'app',
  data() {
    return {
      infolist: [],
      input1: '',
      imagepath:'',
      index: '',
      activeIndex2: '1',
      newslist: [],
      leftBigIma:{},
      topImg:{},
      down:{},
      leftBigIndex:1,
      homeList:[],
    }
  },

  created() {
    this.getNews()
    this.getInfo()
    this.getHomePage()
  },
  mounted(){
    this.timer = setInterval(() => {
      if(this.leftBigIndex==this.homeList.length){
        this.leftBigIndex=0
      }
     this.getHome(this.leftBigIndex,this.homeList);
     this.leftBigIndex++
   }, 8000)

  },
  methods: {
    bushow() {
      this.axios.post("/user/userLogin", "username=" + this.input1 + "&password=123")
        .then(resp => {
          if (resp.data.status == 1) {
            alert("正确")
          } else {
            alert("测试用户名不正确")
          }
        })
        .catch((err) => {
          alert("出错了")
          console.log(err)
        })
    },getLocaltypes(){
  return getLocaltype();
},
    toRouter(data){
      console.log('ddd',data)
      this.$router.push({  //核心语句
        path:data.homPageRouter,   //跳转的路径
      })
    },
    handleSelect(key, keyPath) {

    },
    getNews() {
       this.imagepath=this.$imagepath
      this.axios.post("/news/getNewsShow")
        .then(resp => {
          if (resp.data.status == 1) {
            this.infolist = resp.data.result;
                        this.newslist = resp.data.result
          } else {
            alert("拿取数据失败")
          }
        })
        .catch((err) => {
          // alert("出错了")
          console.log(err)
        })

    },
    getInfo() {
      this.axios.post("/info/getInfo")
        .then(resp => {
          if (resp.data.status == 1) {
            this.infolist = resp.data.result;
          } else {
            alert("拿取数据失败")
          }
        })
        .catch((err) => {
          // alert("出错了")
          console.log(err)
        })
    },
     getHomePage(){
         this.axios.post("/home/getHomePagebyShow")
          .then(resp => { 
                      if(resp.data.status == 1) {   
                      console.log(resp.data.result)   
                        this.homeList=resp.data.result
                        this.getHome(0,this.homeList);
                                }else {
                                    alert("出错")
                                  this.$message.error(resp.data.message)                           
                                }
                            })
                            .catch((err) => {
                               alert("出错了")
                                console.log(err)
                            }) 
      },getHome(val1,homeList){
       this.down=homeList[val1]
       let numer2=val1+1
      if(numer2==homeList.length){numer2=0}
      this.topImg=homeList[numer2]
      let numer3=numer2+1
       if(numer3==homeList.length){numer3=0}
        this.leftBigIma=homeList[numer3]
      },
      getNew(data){
      this.$router.push({  //核心语句
        path:'/news',   //跳转的路径
        query:{           //路由传参时push和query搭配使用 ，作用时传递参数
          newsid:data.newsid,
          newsHtmlURL:data.newsFilePath
        }
      })
    }
      


  }

}
</script>

<style scoped>


li{
/* border-left: 1px solid black; */

}
.model-big {
  height: 450px;
  margin: auto;
  width: 1200px;
  margin-top: 30px;

}

#Newall {
  text-decoration: none;
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  vertical-align: baseline;
  color: #181818;
}

.right-main {
  height: 100%;
  width: 65%;
  position: static;
 
/* 
  background: url('../../assets/70f8d71f956dc03201d54140dc5906a.jpg');
  background-size: 100% 100%; */
  float: left;

}
img{
  overflow:hidden;
  width: 100%;
  height: 100%;
}
.left-main {
  height: 100%;
  width: 32%;

  float: right;

}
.getAllNews{
  width: 1200px;
  margin: auto;
}
.top {
  position:static;
  width: 100%;
  /* background: url('../../assets/download.jpg'); */
  height: 46.8%;
  float: none;
  /* position: absolute; */
}

.down {

  width: 100%;
  /* background: url('../../assets/download.jpg'); */
  height: 46.8%;
  float: none;
 /* margin-top: 35.2px; */
  margin-top: 28.82px;

}
.topContent{
   position:absolute;
   padding-top: 150px;
  padding-left: 10px;
}
.el-header,
.el-footer {
  background-color: #B3C0D1;
  color: #333;
  text-align: center;
  line-height: 60px;
}



.el-main {
  background-color: #E9EEF3;
  color: #333;
  
display: none;
}




 .search-banner  {
    width: 1200px;
    height: 80px;
    background: #fff;
    margin: 0 auto;
    margin-top: 50px;
    -moz-box-shadow: 0px 0px 0.2rem #BABABA;
    -webkit-box-shadow: 0px 0px 0.2rem #BABABA;
    box-shadow: 0px 0px 0.2rem #BABABA;
  }

  .icon {
    width: 30px;
    height: 50px;
    margin-left: 10px;
    margin-top:20px;
  }
 .icon::before {
    content: '\F002';
    display: block;
    text-indent: 0;
    font-family: "FontAwesome";
    font-size: 30px;
    color: #181818;
     
  }
.search-input {
    flex: 1;
    margin-left: 200px;
    border: none;
    width:800px;
    outline: none;
    font-size: 16px;
    color: #010544;
    text-indent: 0.2rem;
  }
  .search-input::placeholder {
    color: #010544;
  }
.search-btn {
    width: 60px;
    height: 100%;
    background: #010544;
    text-align: center;
    font-size: 18px;
    color: #fff;
    cursor: pointer;
    transition: all 0.4s ease-in-out;
  }
.search-btn:hover {
    background-color: #FFF200;
    color: #010544;
  }
  .who-box {
    width: 15rem;
    margin: 0 auto;
    margin-top: 0.4rem;
  }
.banner-title {
    width: 100%;
    height: 0.4rem;
    font-size: 0.25rem;
    color: #181818;
    line-height: 0.5rem;
    margin-top: 1.46rem;
    position: relative;
  }
  .banner-title::before {
    content: '';
    display: block;
    position: absolute;
    top: -0.05rem;
    left: 0;
    width: 0.3rem;
    height: 0.05rem;
    background-color: #181818;
  }
  .m40 {
    margin-top: 0.4rem;
  }
 .who-box .who-warp {
    margin-top: 1.4rem;
     margin-left: 1.4rem;
    flex-wrap: wrap;
  }
.who-box .who-warp .who-item {
    padding: 0 0.35rem;
    height: 0.34rem;
    -moz-box-shadow: 0px 0px 4px #BABABA;
    -webkit-box-shadow: 0px 0px 4px #BABABA;
    box-shadow: 0px 0px 4px #BABABA;
    margin-right: 1.116rem;
    font-size: 0.18rem;
    line-height: 0.34rem;
    margin-bottom: 0.2rem;
    color: #010544;
    transition: all 0.6s ease;
  }
  

.sear {
  width: 1200px;
  height: 50px;
  margin: auto;
 
  margin-top: 30px;
}

.sear-image {
  width: 5%;
  height: 80%;
   
  float: left;
}

.sear-imput {
  width: 70%;
  float: left;
  height: 80%;

}
.headfont{
  padding-top: 230px;
  padding-left: 50px;
  position: absolute;
  width: 740px;
}
h2{
  font-weight: 500;
  color: #fff;
  font-weight: bold;
  line-height: 1.2;
  margin-bottom: 10px;
  text-transform: uppercase;
  position: relative;
  padding: 13px;
  text-align: left;
 
}
.spanonunt{
   position: relative;
  font-size: 18px;
   color: #fff;
    padding: 13px;
     white-space: normal !important;
}
.topspan{
   white-space: normal !important;
  color: #fff;
 font-size: 25px;
 position: relative;
 font-weight: 400;
 width:350px ;
}
.sear-but {
  width: 10%;
  height: 80%;
  float: left;
  margin-top: -5px;

}

.el-input__inner {
  height: 50px;
}

.el-button {
  line-height: 1.7;
  /* background-color: #010544 ; */
}

.who-box {
  width: 100%;
  height: 127.21px;

  margin-top: 30px;
}

.banner-title {
  width: 1200px;
  height: 40px;
  font-size: 23px;
  line-height: 30px;
  margin: auto;
  /* justify-content: space-between; */
  text-align: left;
  /* position: relative; */

}
.model-big2 {
  margin: auto;
  width: 100%;
  /* margin-top: 30px; */

}
.who-warp {
  width: 100%;
  margin-top: 30px;

}

a {
  margin: 32px;

}
h2{
  font-weight: 500;
    font-size:50px ;
    
}
#middle-box-pure {
  width: 1200px;
  height: 420px;

  margin: auto;

}

#section-title {
  width: 100%;
  height: 38px;

  text-align: left;

  font-size: 23px;
  margin-top: 20px;

}

#text1 {
  font-family: verdana;

}

#news-item {


  margin: 10px;
}

.image1 {
  width: 380px;
  height: 250px;
}

#time-cate {
  width: 120px;
  height: 12px;
  text-align: center;
  padding-left: 10px;
}

#news-title {
  width: 330px;
  height: 120px;
  font-size: 16px;

  margin: 20px;
  word-break: break-all;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  white-space: normal;
}

#model3 {
  float: left;
  
}
a{
  color:white;
  text-decoration: none;
}
/* ul li{
  text-decoration: none;
} */
.con {
    display: true;
    position: relative;
    bottom: 47px;
    left: 50%;
    z-index: 1000;
    margin-left: -40px;
    margin-top: 60px;
    width: 80px;
}



.viewallnews
{
  /* background: cyan; */
  font-size: 18px;
  padding-left: 20px;
  color:dodgerblue;
}

</style>


// WEBPACK FOOTER //
// src/components/work/XJTLU.vue